import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import styles from '../styles/color/index.module.scss'
import { Row, Col, Spin, Tag, Affix, Empty } from 'antd'
import Layout from '../../components/MyLayout'
import { NextPage, NextPageContext } from 'next';
import { colorList } from '../../constants/api'
import { http } from '../../utils/api'
import { useSelector } from 'react-redux'
import { State } from '../../@types/reducer'
import { useRouter } from 'next/router'
import Navigation from '../../components/Color/Navigation';
import ColorItem from '../../components/Color';
import InfiniteScroll from 'react-infinite-scroller';
import { Item } from '../../@types/color';
import Link from 'next/link';
import { colorPrimary } from '../../constants/heads'
const SearchNoSSR = dynamic(() => import('../../components/Color/Search'), {
  ssr: false
})

type PlateProps = {
  list: {
    key: string | string[]
    total: number
    list: Item[]
  }
  type: number
  page: number
  limit: number
  by: string | string[]
  imgUrl: string | string[]
  text: string | string[]
}

const Plate: NextPage<PlateProps> = (props) => {
  const { userInfo, baseUrl, cdnUrl, responsive } = useSelector((state: State) => state)
  const { isXs, isSm, isMd, isXxl } = responsive
  const head = {
    title: `搜图配色-提供千张优质渐变背景及渐变配色`,
    keywords: `渐变调色板,渐变背景,流体背景`,
    description: `拥有近万种渐变背景，每个渐变调色板都是精挑细选。并且自动匹配中文传统色名称，可直接使用在插画、UI、网页、电商、包装等等设计上。`
  }
  const { total } = props.list
  const { by, limit, text, type, imgUrl } = props
  const router = useRouter()
  const [hasMore, setHasMore] = useState(total > limit ? true : false);
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(props.page)
  const [list, setList] = useState(props.list.list)

  const getList = async () => {
    setLoading(true)
    if (loading) return;
    const data: any = await http(colorList, { limit: 40, page, by, type, key: text })
    const resList = data.data.list
    if (data.code == 200 && resList.length > 0) {
      list.push(...resList)
      setList([...list])
      const URL = {
        pathname: router.route,
        query: { ...router.query, p: page },
      }
      router.push(URL, URL, { scroll: false, shallow: true })
      setPage(page + 1)
      if (limit > resList.length) setHasMore(false)
    } else {
      setHasMore(false)
    }

    setLoading(false)
  }

  // useEffect(() => {
  //   const URL = {
  //     pathname: router.route,
  //     query: { ...router.query, p: 1 },
  //   }
  //   router.push(URL, URL, { scroll: false })
  // }, []);

  useEffect(() => {
    setList(props.list.list)
    setPage(props.page)
    setHasMore(total > limit ? true : false)
  }, [by, text, props.page]);

  return (
    <Layout className={styles.color} head={head}>
      <div className="content">
        {/* <Search /> */}
        <Affix offsetTop={0}>
          <div style={{ minHeight: '38px' }}><SearchNoSSR /></div>
        </Affix>
        <Row className="items">
        <Col xs={7} sm={7} md={5} lg={5} xl={3}>
                        <Navigation />
                    </Col>
          <Col className="page" xs={17} sm={17} md={19} lg={19} xl={21}>
            <InfiniteScroll
              pageStart={page}
              loadMore={getList}
              hasMore={!loading && hasMore}
              initialLoad={false}
            >
              <Affix offsetTop={72}>
                <div className="by">
                  <Link key="update_date" href={`${router.pathname}?p=1&by=update_date&text=${router.query.text || ''}`}  >
                    <a>
                      <Tag style={props.by == 'update_date' ? { color: '#fff' } : {}}  color={props.by == 'update_date' ? colorPrimary : '#fff'}>最新</Tag>
                    </a>
                  </Link>
                  <Link key="visit" href={`${router.pathname}?p=1&by=visit&text=${router.query.text || ''}`}  >
                    <a>
                      <Tag style={props.by == 'visit' ? { color: '#fff' } : {}}  color={props.by == 'visit' ? colorPrimary : '#fff'}>最热</Tag>
                    </a>
                  </Link>
                  <Link key="like" href={`${router.pathname}?p=1&by=like&text=${router.query.text || ''}`}  >
                    <a>
                      <Tag style={props.by == 'like' ? { color: '#fff' } : {}}  color={props.by == 'like' ? colorPrimary : '#fff'}>收藏</Tag>
                    </a>
                  </Link>
                </div>
              </Affix>
              <Row gutter={[20, 20]}>
                {list.map((item, k) => (
                  <Col key={k} xs={24} sm={24} md={12} lg={8} xl={6}>
                    <ColorItem imgUrl={imgUrl} item={item} />
                  </Col>
                ))}
              </Row>
              {loading && hasMore && (
                <div style={{ textAlign: 'center', lineHeight: '50px', marginTop: '20px' }} key={0}><Spin tip="努力加载中..." /></div>
              )}
              {!list[0] && <Empty />}
            </InfiniteScroll>
          </Col>
        </Row>
      </div>
    </Layout >
  )
}

Plate.getInitialProps = async ({ req, res, err, query }: NextPageContext) => {
  const text = query.text ? String(query.text).replace(/@/g, '#') : ''
  const page = query.p || 1;
  const by = query.by || 'update_date'
  const limit = 40
  const type = 2

  const data: any = await http(colorList, {
    type,
    limit,
    page,
    by,
    key: text,
  }, req)

  return {
    page: Number(page) + 1,
    list: data.data,
    imgUrl: data.data.imgUrl,
    limit,
    by,
    text,
    type
  }
}

export default Plate